import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ChemicalOrderStatusEnum } from '../../../enums/chemicalOrderStatusEnum';
import { StatusText } from './ChemicalOrder.styles';
import { StatusIcon } from '../TankCleaningIcons.styles';

type Props = {
    chemicalOrderStatus: ChemicalOrderStatusEnum;
    type: string;
    inButton?: boolean;
    rightPos?: string;
};

const OrderStatus: React.FC<Props> = (props) => {
    return (
        <>
            {props.type === 'icon' && (
                <>
                    {props.chemicalOrderStatus === ChemicalOrderStatusEnum.Unsaved && (
                        <StatusIcon className="status-icon status-unsaved" inButton={props.inButton} rightPos={props.rightPos}>
                            <FontAwesomeIcon icon="dolly" title="" />
                        </StatusIcon>
                    )}
                    {props.chemicalOrderStatus === ChemicalOrderStatusEnum.Draft && (
                        <StatusIcon className="status-icon status-draft" inButton={props.inButton} rightPos={props.rightPos}>
                            <FontAwesomeIcon icon="dolly" title="Order has been saved" />
                        </StatusIcon>
                    )}
                    {props.chemicalOrderStatus === ChemicalOrderStatusEnum.SentToOperator && (
                        <StatusIcon className="status-icon status-sent-to-operator" inButton={props.inButton} rightPos={props.rightPos}>
                            <FontAwesomeIcon icon="dolly" title="Order has been sent to operator" />
                        </StatusIcon>
                    )}
                    {props.chemicalOrderStatus === ChemicalOrderStatusEnum.Canceled && (
                        <StatusIcon className="status-icon status-canceled" inButton={props.inButton} rightPos={props.rightPos}>
                            <FontAwesomeIcon icon="dolly" title="Order has been canceled" />
                        </StatusIcon>
                    )}
                    {props.chemicalOrderStatus === ChemicalOrderStatusEnum.Ordered && (
                        <StatusIcon className="status-icon status-ordered" inButton={props.inButton} rightPos={props.rightPos}>
                            <FontAwesomeIcon icon="dolly" title="Order has been sent to vendor" />
                        </StatusIcon>
                    )}
                    {props.chemicalOrderStatus === ChemicalOrderStatusEnum.Confirmed && (
                        <StatusIcon className="status-icon status-confirmed" inButton={props.inButton} rightPos={props.rightPos}>
                            <FontAwesomeIcon icon="dolly" title="Vendor has confirmed delivery of order" />
                        </StatusIcon>
                    )}
                </>
            )}
            {props.type === 'text' && (
                <>
                    <StatusText className={props.chemicalOrderStatus === ChemicalOrderStatusEnum.Draft ? 'status-draft' : ''}>
                        <span className="status-text">1.Draft</span>
                    </StatusText>
                    <StatusText className={props.chemicalOrderStatus === ChemicalOrderStatusEnum.SentToOperator ? 'status-sent-to-operator' : ''}>
                        <span className="status-text">2.Sent to operator</span>
                    </StatusText>
                    <StatusText className={props.chemicalOrderStatus === ChemicalOrderStatusEnum.Ordered ? 'status-ordered' : ''}>
                        <span className="status-text">3.Ordered</span>
                    </StatusText>
                    <StatusText className={props.chemicalOrderStatus === ChemicalOrderStatusEnum.Confirmed ? 'status-confirmed' : ''}>
                        <span className="status-text">4.Confirmed</span>
                    </StatusText>
                    {props.chemicalOrderStatus === ChemicalOrderStatusEnum.Canceled && (
                        <StatusText className="status-canceled">
                            <span className="status-text">Canceled</span>
                        </StatusText>
                    )}
                </>
            )}
        </>
    );
};

export default OrderStatus;
